// extracted by mini-css-extract-plugin
module.exports = {"pc_only":"Switch__pc_only___2yZAD","sp_only":"Switch__sp_only___2hEPT","container":"Switch__container___zGzRo","item":"Switch__item___15vfe","selected":"Switch__selected___22ssF"};